import { createSvgIcon } from "@mui/material/utils";
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (path, name) {
  return createSvgIcon( /*#__PURE__*/_jsx("path", {
    d: path
  }), name);
});